import { render, staticRenderFns } from "./menusTwo.vue?vue&type=template&id=9680e270&scoped=true"
import script from "./menusTwo.vue?vue&type=script&lang=js"
export * from "./menusTwo.vue?vue&type=script&lang=js"
import style0 from "./menusTwo.vue?vue&type=style&index=0&id=9680e270&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9680e270",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9680e270')) {
      api.createRecord('9680e270', component.options)
    } else {
      api.reload('9680e270', component.options)
    }
    module.hot.accept("./menusTwo.vue?vue&type=template&id=9680e270&scoped=true", function () {
      api.rerender('9680e270', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menusTwo.vue"
export default component.exports